<div class="d-flex align-items-center">
    <div class="form-check form-check-inline mb-0" *ngFor="let option of options" (click)="onDisabledOptionClick(option)">
        <input type="radio"
               [id]="radioGroupName + '-' + option.value"
               [name]="radioGroupName"
               [value]="option.value"
               [(ngModel)]="selectedValue"
               [checked]="selectedValue === option.value"
               [disabled]="option.disabled"
               (change)="onValueChange(option.value)">
        <label class="form-check-label top-0 ml-1 position-relative"
               [for]="radioGroupName + '-' + option.value" [class.disabled]="option.disabled">{{ option.label }}</label>
    </div>
</div>
